export default (phone) => {
  let formattedPhone = ''

  if (Array.isArray(phone)) {
    phone.forEach(el => {
      formattedPhone += `${el}<br>`
    })
  } else {
    formattedPhone = phone
  }

  return formattedPhone
}
